import { useSubsequentEffect } from '@carvana/vdp-react-hooks';
import Router from 'next/router';
import { useContext } from 'react';
import SortOption from '~/constants/SortOption';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { stringifyAndEncode, stripEquals } from '~/utilities/crypto';

const emptyObjects = [
  stripEquals(stringifyAndEncode({})),
  stripEquals(stringifyAndEncode({ filters: {} }))
];

export default function useSetCvnaId() {
  const context = useContext(AppliedFiltersContext);
  const sortBy =
    context.sortBy === SortOption.MostPopular ? undefined : context.sortBy;

  // Update cvnaid in URL
  useSubsequentEffect(() => {
    const cvnaId = stripEquals(
      stringifyAndEncode({ filters: context.appliedFilters, sortBy })
    );
    const url = new URL(window.location.href);

    if (emptyObjects.includes(cvnaId)) {
      url.pathname = '/cars';
      url.searchParams.delete('cvnaid');
    } else {
      url.pathname = '/cars/filters';
      url.searchParams.set('cvnaid', cvnaId);
    }

    if (window.location.href !== url.toString()) {
      url.searchParams.delete('page'); // Preemptively remove page number so only one history entry is created

      void Router.push(url, undefined, { shallow: true });
    }
  }, [context.appliedFilters, sortBy]);
}
